import { User } from '../models';

// All sort functions implement a public normal and reverse function so we can use them in places
// that are expecting a (a: Type, b: Type) function signature.

// User Sort
const userSort = (a: User, b: User, reverse?: boolean) => {
    if (a.lastName === b.lastName) {
        if (a.lastName === b.lastName) {
            return 0;
        } else if (a.lastName < b.lastName) {
            return reverse ? 1 : -1;
        } else {
            return reverse ? -1 : 1;
        }
    } else if (a.lastName < b.lastName) {
        return reverse ? 1 : -1;
    } else {
        return reverse ? -1 : 1;
    }
};

export function UserSort (a: User, b: User) {
    return userSort(a, b);
}

export function UserSortReverse (a: User, b: User) {
    return userSort(a, b, true);
}


// WEBPACK FOOTER //
// ./src/utilities/SortUtilities.ts